import React, { useState } from 'react';
import { isEmpty } from 'lodash-es';
import { ArrowDownIcon, ArrowUpIcon } from 'components/common/SVGIcon';

interface ExtraValue {
  yesOrNo: string;
  className: string;
  hasArrowIcon: boolean;
  detailedValue?: string;
  detailedTitle: string;
}
interface Props {
  value: string | number;
  icon: JSX.Element;
  className?: string;
  extraValue?: ExtraValue;
}

const ContactInfoItem = ({ value, icon, className, extraValue }: Props) => {
  const [collapseDetailedValue, setCollapseDetailedValue] = useState(true);

  const updateCollapseAllergies = () => {
    setCollapseDetailedValue(!collapseDetailedValue);
  };

  return (
    <>
      {isEmpty(value) ? null : (
        <div className="text-16">
          <div className="flex">
            <div className="text-primary">{icon}</div>
            <div className={`ml-8 text-black-800 ${className}`}>
              {`${value} `}
              {extraValue && (
                <>
                  <span
                    onClick={updateCollapseAllergies}
                    role="presentation"
                    className={extraValue.className}
                  >
                    {`${extraValue?.yesOrNo} `}
                    <span className="text-16">
                      {extraValue?.hasArrowIcon &&
                        (collapseDetailedValue ? (
                          <ArrowUpIcon />
                        ) : (
                          <ArrowDownIcon />
                        ))}
                    </span>
                  </span>
                  <br />
                  <span>
                    {extraValue?.hasArrowIcon && collapseDetailedValue && (
                      <span>
                        {`${extraValue?.detailedTitle}: `}
                        <strong>{extraValue?.detailedValue}</strong>
                      </span>
                    )}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactInfoItem;
